import type { ReactNode } from 'react';
import { sessao } from './session-store';
import { GestorSwitchModal } from '@/components/shared/GestorSwitchModal';

/**
 * Impede que módulos protegidos montem antes de a sessão ter um `cnpj_gestor`.
 *
 * Um JWT sem `cnpj_gestor` é uma sessão autenticada mas ainda incompleta —
 * seguir adiante faria toda query com CNPJ do gestor disparar sem ele. O
 * seletor valida o vínculo no backend (`Auth/SelecionarGestor`), reemite o
 * par access/refresh já com `cnpj_gestor` embutido e só então (via reload)
 * a árvore autenticada monta de novo.
 */
export function RequireGestor({ children }: { children: ReactNode }) {
  const temGestor = Boolean(sessao().cnpjGestor?.trim());
  if (temGestor) return <>{children}</>;

  return (
    <main className="flex min-h-screen items-center justify-center bg-muted/40 px-4 py-10">
      <section className="w-full max-w-md rounded-2xl border bg-card p-7 shadow-lg">
        <GestorSwitchModal open onOpenChange={() => {}} obrigatorio />
      </section>
    </main>
  );
}
